import { render, staticRenderFns } from "./404.vue?vue&type=template&id=4a4b3563&scoped=true&"
import script from "./404.vue?vue&type=script&lang=js&"
export * from "./404.vue?vue&type=script&lang=js&"
import style0 from "./404.vue?vue&type=style&index=0&lang=css&"
import style1 from "./404.vue?vue&type=style&index=1&id=4a4b3563&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4b3563",
  null
  
)

export default component.exports